import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction, therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
    GET_MDS_ASSESSMENT_RANGE_REQUEST,
    GET_MDS_ASSESSMENT_RANGE_SUCCESS,
    GET_MDS_ASSESSMENT_RANGE_FAILURE,
    GET_MDS_ASSESSMENT_RANGE_LOADING,
    GET_MDS_ASSESSMENT_RANGE_RESET,
} = therapyPlanningAction;

function* getMdsAssessmentRange(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_MDS_ASSESSMENT_RANGE_LOADING });

    const reponse = yield call(therapyPlanningService.getMdsAssessmentRange, payload.payload);
    if (reponse?.status === 200) {
      yield put({
        type: GET_MDS_ASSESSMENT_RANGE_SUCCESS,
        payload: reponse?.data,
      });
    } else throw reponse.data;
  } catch (error) {
    yield put({ type: GET_MDS_ASSESSMENT_RANGE_FAILURE, payload: error });
  }
}

function* getMdsAssessmentRangeSaga() {
  yield takeEvery(GET_MDS_ASSESSMENT_RANGE_REQUEST, getMdsAssessmentRange);
}

export default getMdsAssessmentRangeSaga;
